export default __webpack_public_path__ + "static/media/facebook-color-square.c2e382e0.svg";